import React from 'react';
import { NavLink } from 'react-router-dom';
import Logo from '../ds/Logo';
import Button from '../ds/Button';
import Icon from '../lib/Icon';
import { useUser } from '../../contexts/ContextUser';

const NAV = [
  { id: 'engagements', label: 'Engagements', icon: 'layers', to: '/console', end: true },
  { id: 'reports', label: 'Reports', icon: 'file', to: '/console/reports' },
  { id: 'resources', label: 'Resources', icon: 'folder', to: '/console/resources' },
  { id: 'settings', label: 'Settings', icon: 'settings', to: '/console/settings' },
];

export default function Sidebar() {
  const { user } = useUser();
  const tokens = (user.account && user.account.tokens_available && user.account.tokens_available.assessment) || 0;
  const reportTokens = (user.account && user.account.tokens_available && user.account.tokens_available.team_report) || 0;
  return (
    <aside style={{
      width: 240, flex: 'none', background: 'var(--neutral-900)', color: 'var(--on-ink)',
      display: 'flex', flexDirection: 'column', padding: '22px 16px',
      position: 'sticky', top: 0, alignSelf: 'flex-start', height: '100vh', boxSizing: 'border-box',
    }}>
      <NavLink to="/console" style={{ padding: '4px 8px 26px', display: 'block' }}>
        <Logo variant="lockup" size={19} color="var(--on-ink)" markColor="var(--science-400)" />
      </NavLink>
      <nav style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {NAV.map((it) => (
          <NavLink
            key={it.id}
            to={it.to}
            end={it.end}
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: 12, padding: '11px 12px',
              borderRadius: 'var(--radius-md)', textDecoration: 'none',
              background: isActive ? 'color-mix(in srgb, var(--science-400) 16%, transparent)' : 'transparent',
              color: isActive ? 'var(--science-400)' : 'color-mix(in srgb, var(--on-ink) 72%, transparent)',
              fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-medium)',
              fontSize: 'var(--text-sm)', letterSpacing: 'var(--track-tight)',
            })}
          >
            <Icon name={it.icon} size={18} />
            {it.label}
          </NavLink>
        ))}
      </nav>
      <div style={{ marginTop: 'auto', display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div style={{
          display: 'flex', flexDirection: 'column', gap: 10,
          padding: '12px 14px', borderRadius: 'var(--radius-md)', background: 'color-mix(in srgb, var(--on-ink) 6%, transparent)',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 'var(--text-sm)', color: 'color-mix(in srgb, var(--on-ink) 70%, transparent)' }}>
              <Icon name="coins" size={16} fill style={{ color: 'var(--gfx-gold)' }} />
              Tokens
            </span>
            <b style={{ fontFamily: 'var(--font-display)', fontSize: 'var(--text-lg)' }}>{tokens}</b>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 'var(--text-sm)', color: 'color-mix(in srgb, var(--on-ink) 70%, transparent)' }}>
              <Icon name="file" size={16} style={{ color: 'var(--gfx-gold)' }} />
              Report tokens
            </span>
            <b style={{ fontFamily: 'var(--font-display)', fontSize: 'var(--text-lg)' }}>{reportTokens}</b>
          </div>
        </div>
        <Button href="/book_time" variant="outline" size="sm" block
          style={{
            // On-dark overrides: Button's hover reads --bg-press off the element,
            // so retargeting the palette vars keeps the label legible on ink.
            '--fg': 'var(--on-ink)',
            '--bd': 'color-mix(in srgb, var(--on-ink) 40%, transparent)',
            '--bg-press': 'color-mix(in srgb, var(--on-ink) 12%, transparent)',
          }}
          iconLeft={<Icon name="calendar" size={16} />}>
          Schedule a call
        </Button>
      </div>
    </aside>
  );
}
